<!--TODO https://syncdev.atlassian.net/browse/UX-2380-->
<app-dialog-error
    *ngIf="!initialized && errcode && openState === 99"
    [dialogConfig]="dialogConfig"
    [openState]="openState"
    [errcode]="errcode">
</app-dialog-error>

<app-link-create
    *ngIf="item && item.type && (openState === 0 || openState === 5)"
    [item]="item"
    [openState]="openState"
    [fileType]="item.type"
    [fileName]="item.name"
    [onLinkMutate]="onLinkMutate"
    (state)="onStateChange($event)"
    (close)="close($event)">
</app-link-create>

<app-link-manage
    *ngIf="openState === 1 && initialized"
    [item]="item" [link]="link"
    [fileType]="item.type"
    [fileName]="item.name"
    (formDataSaved)="saveFormData($event)"
    (state)="onStateChange($event)"
    (close)="close($event)">
</app-link-manage>

<app-link-settings
    *ngIf="openState === 2 && initialized"
    [item]="item"
    [link]="link"
    [openState]="openState"
    [fileType]="item.type"
    [fileName]="item.name"
    [savedFormData]="savedFormData"
    (state)="onStateChange($event)"
    (close)="close($event)">
</app-link-settings>

<app-link-delete
    *ngIf="openState === 3 && initialized"
    [link]="link"
    [fileName]="item.name"
    [onLinkMutate]="onLinkMutate"
    (state)="onStateChange($event)"
    (close)="close($event)">
</app-link-delete>

<app-link-share
    *ngIf="openState === 4 && initialized"
    [openState]="openState"
    [link]="link"
    [fileName]="item.name"
    (state)="onStateChange($event)"
    (close)="close($event)">
</app-link-share>
